export class PermissionsClass {
  constructor(permissions = []) {
    this.permissions = permissions;
  }

  isExist(permission) {
    return this.permissions.includes(permission);
  }
}
